import { Component, Input, OnInit, AfterViewInit, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartType } from 'chart.js';

@Component({
  standalone: false,
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartComponent implements OnInit, AfterViewInit {
  @ViewChild(BaseChartDirective)
  chart!: BaseChartDirective;

  @Input()
  chartType!: ChartType;

  @Input()
  title?: string;

  @Input()
  subtitle?: string;

  @Input()
  chartOptions!: any;

  @Input()
  chartData!: any;

  constructor() {
    this.resetChart();
  }

  ngOnInit() {
    this.resetChart();
  }

  ngAfterViewInit() {
    this.drawChart();
  }

  drawChart() {
    this.chart.update();
  }

  private resetChart() {
    this.chartData = [];
  }
}
